export async function isMobile() {
    const functionObserverMain = new ResizeObserver(body => {
        // 1220 - 17 ( Barra scrool ) = 1203 = Ativa responsivo ao conteudo interno
        if (document.body.clientWidth < ( 1220 - 17 )) { // Para alterar esse valor, verificar com Eduardo Tell
            document.querySelector("body").classList.add("mobile")
            document.querySelector("body").classList.remove("desktop")
        } else {
            document.querySelector("body").classList.add("desktop")
            document.querySelector("body").classList.remove("mobile")
        }

        return document.querySelector("body").classList.contains("mobile")
    })

    functionObserverMain.observe(document.querySelector("body"))
}
